const defaultState = {
  externalServicesIncidents: {
    byId: {},
    allIds: []
  }
};
export default defaultState;